<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" lg="6">
          <v-sheet class="neu-glow with-radius fill-height" height="100%">
            <v-img
              src="/static/ob-animated-isometric/end-of-workday-animate.svg"
              lazy-src="/static/ob-animated-isometric/end-of-workday-animate.svg"
              height="400"
              contain
            >
            </v-img>
            <v-row justify="end" class="fill-height">
              <v-col class="text-center px-10" cols="12">
                <h3 class="mb-1">
                  {{$t(page+'.You have logged out')}}
                </h3>                
              </v-col>
              <v-col class="text-center px-10" cols="12">
                <div class="text-body-1 mb-5">
                  {{$t(page+'.Have a nice day')}} <br />
                   {{$t(page+'.see you soon')}}
                </div>
                <v-btn
                  color="info"
                  to="/auth/login"
                  class="mb-5"
                  >{{$t(page+'.Opps Login Again')}}</v-btn
                >
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>


<script>

export default {
  created(){
    sessionStorage.removeItem('jwt');
    sessionStorage.removeItem('csrf');
    sessionStorage.removeItem('jwt_b');
    sessionStorage.removeItem('settings');
    sessionStorage.removeItem('setupToken');
    localStorage.removeItem('user_b');
    localStorage.removeItem('user');
    document.title = 'iBookrestaurant | logout';
  },
  data() 
  {
    return {
      page:'Auth'
    }
  }
};
</script>
